import React, { useContext, useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux'
import { Form, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import API, { ResponseManagement, ErrorManagement } from '../../../API';
import Utility from '../../../Utility';
import ModalTransition from '../../ModalTransition/ModalTransition';
import GlobalContext from '../../../contexts/GlobalContext';
import { RootDispatch, RootState } from '../../../store';

const mapProps = (state: RootState) => ({
  bookingFolder: state.booking.bookingFolder,
  selectedBooking: state.booking.selectedBooking,
  updateBookingModal: state.modal.updateBookingModal,
})

const mapDispatch = (dispatch: RootDispatch) => ({
  handleModal: dispatch.modal.handleModal,
})

const ModalRequestUpdateBooking = ({
  bookingFolder, selectedBooking, handleModal, updateBookingModal
}) => {
    const [globalContext] = useContext(GlobalContext) as any;
    const [loading, setLoading] = useState(false)
    const [valueTextState, setValueTextState] = useState('');

    useEffect(() => {
      if (updateBookingModal === true) {
        setValueTextState('');
      }
    }, [updateBookingModal]);

    const handleClose = () => handleModal({updateBookingModal: false})

    const handleChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => setValueTextState(e.target.value)

    const handleClickRequestUpdateBooking = useCallback(() => {
      const msg = valueTextState.trim()
      if (msg !== '') {
        setLoading(true)
    
        API.post(Utility.getUrlAjax() + `/sendBookingUpdateMessageAction`, new URLSearchParams({
          bookingFolderId: bookingFolder.id,
          bookingId: selectedBooking.id,
          message: msg,
        }))
        .then(response => {
          ResponseManagement(response,
            () => {
              toast.success(response.data.data.message);
            },
            () => {
              toast.error(response.data.data.message);
            }
          );
        })
        .catch(error => {
          ErrorManagement(error, () => {});
        })
        .finally(() => {
          setLoading(false)
          handleModal({updateBookingModal: false})
        })
      } else {
        toast.error(globalContext.translations.errorMsgEmpty)
      }
      
    }, [bookingFolder, selectedBooking.id, valueTextState])

    return (
      <ModalTransition
        size="tiny"
        open={updateBookingModal}
        handleClose={handleClose}
        header={globalContext.translations.headerModalRequestUpdateBooking}
        content={
          <Form>
            <Form.TextArea 
              rows={8} 
              value={valueTextState} 
              placeholder={globalContext.translations.contentModalRequestUpdateBooking} 
              onChange={handleChangeText} 
            />
          </Form>
        }
        actions={
          <div>
            <Button
              color="grey"
              icon="delete"
              labelPosition="right"
              content={globalContext.translations.preCheckInCancel}
              onClick={handleClose} 
            />
            <Button
              loading={loading}
              positive
              icon="send"
              labelPosition="right"
              content={globalContext.translations.validate}
              onClick={handleClickRequestUpdateBooking}
            />
          </div>
        }
      />
    )
}

export default connect(mapProps, mapDispatch)(ModalRequestUpdateBooking);